import { render, staticRenderFns } from "./inspects.vue?vue&type=template&id=3187030b&"
import script from "./inspects.vue?vue&type=script&lang=js&"
export * from "./inspects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports